import { InjectionToken } from '@angular/core';
import { FilterState } from '@softapps/core/filter';
import { DeliveryNoteQueryRow } from './types/delivery-note-query-row';

/** Same document-query service the sales module reads; this module only ever asks for
 *  `DELIVERY_NOTE`. */
export const SOFTLINE_API_DELIVERY_NOTE_QUERY =
  '/document-query-service/document/query/{{documentType}}';
export const SOFTLINE_API_DELIVERY_NOTE_QUERY_ICONS =
  '/document-query-service/document/query/icons';
/** The Textbausteine kept in SoftTOP; `usage` narrows them (`GRUND_MENGEN_AENDERUNG` for the Vermerk of a correction). */
export const SOFTLINE_API_TEXT_SUGGESTIONS =
  '/sales-document-service/sales-document-service/meta/text-suggestions';
export const SOFTLINE_API_DELIVERY_NOTE_COMMISSIONING_STAGES =
  '/document-query-service/document/query/commissioning-stages';

/** The sales document service's correction contract (same strings as the sales constants,
 *  OpenAPI-derived, Ticket 452644). */
export const SOFTLINE_API_DELIVERY_NOTE_DOCUMENT =
  '/sales-document-service/sales-document-service/documents/{{id}}';
export const SOFTLINE_API_DELIVERY_NOTE_CORRECTION =
  '/sales-document-service/sales-document-service/documents/{{id}}/correction';
export const SOFTLINE_API_DELIVERY_NOTE_CORRECTION_VALIDATE =
  '/sales-document-service/sales-document-service/documents/{{id}}/correction/validate';
export const SOFTLINE_API_DELIVERY_NOTE_CORRECTION_PRODUCT =
  '/sales-document-service/sales-document-service/documents/{{id}}/correction/products/{{productId}}';
export const SOFTLINE_API_DELIVERY_NOTE_STORAGE_LOCATIONS =
  '/sales-document-service/sales-document-service/stocks/{{stockId}}/storage-locations';
export const SOFTLINE_API_DELIVERY_NOTE_STORAGE_LOCATION_SCAN =
  '/sales-document-service/sales-document-service/stocks/{{stockId}}/storage-locations/scan/{{barcode}}';
export const SOFTLINE_API_DELIVERY_NOTE_STORAGE_LOCATION_PROPOSAL =
  '/sales-document-service/sales-document-service/stocks/{{stockId}}/storage-locations/proposal';

export const SOFTLINE_FILTER_WWS_DELIVERY_NOTE_CORRECTION = new InjectionToken<
  FilterState<DeliveryNoteQueryRow>
>('SOFTLINE_FILTER_WWS_DELIVERY_NOTE_CORRECTION');
